import type { NotificationsState } from "../../../../../components/NotificationAlerts/types";
import type { AppSelector } from "../../../../types";

const getModel: AppSelector<NotificationsState> = (state) => state.notifications;

export const getNotificationData: AppSelector<NotificationsState> = getModel;

export const isNotificationShown: AppSelector<boolean> = (state) => getModel(state).show;
